import { createApp } from 'vue'
import './assets/main.css'
import App from './App.vue'
import Toast from "vue-toastification"
import "vue-toastification/dist/index.css"
import PermissionDirective from './v-permission'
import router from './router'
import store from './store'

import permissionsPlugin from './plugins/permissions'

// 👇 ACTIVA el registro del Service Worker
import './registerServiceWorker'

const app = createApp(App)

app.directive('permission', PermissionDirective)

app.use(store)
app.use(router)

// ✅ global $canView()
app.use(permissionsPlugin, { store })

app.use(Toast, {
  position: 'top-right',
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: true,
  closeButton: 'button',
  icon: true,
  rtl: false
})

app.mount('#app')
